import { FileDownloadOutlined } from "@mui/icons-material";

interface DocumentCardProps {
  title?: string;
  fileName: string;
  onDownload?: () => void;
  onPreview?: () => void;
}

const DocumentCard: React.FC<DocumentCardProps> = ({ title, fileName, onDownload, onPreview }) => {
  return (
    <div className="border rounded p-4 w-full border-[#F1F2F4]">
      <h3 className="font-bold text-base mb-2">{title}</h3>
      <div className="flex justify-between items-center mb-2 w-full">
        <button
          type="button"
          rel="noopener noreferrer"
          className="text-blue-600 underline break-all cursor-pointer"
          onClick={onPreview}
        >
          {fileName}
        </button>
        <button onClick={onDownload} className="cursor-pointer" title="Download">
          <FileDownloadOutlined />
        </button>
      </div>
    </div>
  );
};

export default DocumentCard;
